import {createContext} from 'react';
import type {QueryObserverResult} from '@tanstack/react-query';
import type {BackofficeUserDTO} from '@/api-endpoints/endpoints';

export type AuthContextType = {
  status: 'idle' | 'loading' | 'authenticated' | 'unauthenticated' | 'error';
  error: Error | null;
  logout: () => Promise<void>;
  refetchCheckAuth: () => Promise<
    QueryObserverResult<BackofficeUserDTO | null, Error>
  >;
};

export const AuthContext = createContext<AuthContextType | undefined>(
  undefined,
);
